import type { IExtendedTelemetryItem } from '@microsoft/1ds-analytics-web-js';
import { LogRow } from './logger.log-row';
import { GlobalVariables } from 'app/services/globals';

export class MetricRow extends LogRow {
    constructor(
        private name: string,
        private average: number,
        private sampleCount?: number,
        private min?: number,
        private max?: number,
        properties?: Record<string, unknown>) {
        super(properties);
    }

    public generateLoggingEntry(mergeAll?: boolean): [IExtendedTelemetryItem, unknown] | Record<string, unknown> {
        return !mergeAll ? [
            {
                name: 'CustomMetrics',
                data: { metricName: this.name, average: this.average, sampleCount: this.sampleCount, min: this.min, max: this.max }
            },
            this.properties
        ] : {
            name: 'CustomMetrics',
            data: {
                metricName: this.name, average: this.average, sampleCount: this.sampleCount, min: this.min, max: this.max,
                ...(this.properties || {})
            }
        };
    }

    public pushToAppInsights(): void {
        setTimeout(() => {
            if (GlobalVariables.enableAriaLogger) {
                oneDSWeb.trackEvent(...(this.generateLoggingEntry() as [IExtendedTelemetryItem, unknown]));
            } else {
                appInsights.trackMetric(this.name, this.average, this.sampleCount, this.min, this.max, this.properties);
            }
        }, 0);
    }
}
